
/* reading progress under the menu bar, and the current section in the side list */
(function(){
  var nav=document.querySelector('nav.main'),art=document.querySelector('.prose');if(!nav||!art)return;
  var bar=document.createElement('span');bar.className='ar-prog';bar.setAttribute('aria-hidden','true');nav.appendChild(bar);
  var heads=[].slice.call(art.querySelectorAll('h2[id]')),links=[].slice.call(document.querySelectorAll('.ar-toc a')),raf;
  function upd(){
    var r=art.getBoundingClientRect(),h=r.height-window.innerHeight*.5;
    bar.style.width=(Math.min(1,Math.max(0,(120-r.top)/(h>0?h:1)))*100)+'%';
    var cur=null,line=window.innerHeight*.3;heads.forEach(function(x){if(x.getBoundingClientRect().top<line)cur=x.id;});
    links.forEach(function(a){a.classList.toggle('on',a.getAttribute('href')==='#'+cur);});
  }
  window.addEventListener('scroll',function(){cancelAnimationFrame(raf);raf=requestAnimationFrame(upd);},{passive:true});
  window.addEventListener('resize',upd);upd();
  /* the mobile list closes, then jumps */
  var m=document.querySelector('.ar-toc-m');
  if(m)m.addEventListener('click',function(e){var a=e.target.closest('a');if(!a)return;var t=document.getElementById(a.getAttribute('href').slice(1));if(!t)return;
    e.preventDefault();m.open=false;t.scrollIntoView({behavior:'smooth',block:'start'});try{history.replaceState(null,'','#'+t.id);}catch(x){}});
})();
